import { style } from 'typestyle'

export const FListCard_TagsRow_Container = style({
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    columnGap: '4px',
    rowGap: '4px',
})
